import React from 'react';
import { useTranslation } from 'react-i18next';
import { Link, Navigate, Outlet, useLocation } from 'react-router-dom';
import { storage } from '@/utils/storage';
import { isTokenUsable, tokenHasPermission } from '../utils/jwtPermissions';

interface RequirePermissionProps {
  permission: string | string[];
}

const RequirePermission: React.FC<RequirePermissionProps> = ({ permission }) => {
  const { t } = useTranslation();
  const location = useLocation();
  const token = storage.getAccessToken();

  if (!isTokenUsable(token)) {
    return <Navigate to="/login" replace state={{ from: location.pathname + location.search }} />;
  }

  const hasPermission = Array.isArray(permission)
    ? permission.some((candidate) => tokenHasPermission(token, candidate))
    : tokenHasPermission(token, permission);

  if (!hasPermission) {
    return (
      <section className="mx-auto flex min-h-[420px] max-w-xl flex-col items-center justify-center rounded-[20px] border border-outline-variant bg-white px-6 text-center shadow-sm">
        <span className="material-symbols-outlined text-5xl text-error">lock</span>
        <h1 className="mt-4 font-h1 text-h1 text-on-surface">{t('admin.users.access_denied.title')}</h1>
        <p className="mt-2 text-body-md text-secondary">{t('admin.users.access_denied.description')}</p>
        <Link className="mt-5 rounded-lg bg-primary px-4 py-2 font-label-md text-on-primary" to="/admin">
          {t('admin.users.access_denied.back')}
        </Link>
      </section>
    );
  }

  return <Outlet />;
};

export default RequirePermission;
